module.exports = __webpack_public_path__ + "img/zbanner1-min.942cc605.jpg";